import $ from "jquery";
export default class LogoutButton {
    constructor($container) {
        this.$container = $container;
        $container.on("click", () => {
            const expires = ";expires=" + new Date(0).toUTCString();
            document.cookie.split(";").forEach((cookie) => {
                const name = cookie.split("=")[0].trim();
                if (name === "newsletter" || name.startsWith("newsletter-")) {
                    document.cookie = name + "=" + expires + "; path=/";
                }
            });
            var url = window.location.href;
            url = url.split('?')[0];
            window.location.href = url + "?logout=true";
        });
    }
    static mount(selector = ".btn-logout") {
        const elements = $(selector);
        elements.each(function () {
            new LogoutButton($(this));
        });
    }
}
